<template>
    <div ref="filemanager-container">
        <app-create-folder 
            :active="showCreateFolder" 
            :current="currentPath" 
            @closeCreateFolderModal="closeModalCreateFolder" 
            @refresh="refreshCurrent" 
            @close="closeModalCreateFolder" 
        />

        <div class="box box--p-0 relative" id="filemanager-manager">
            <div class="w-full">
                <div class="p-4 flex items-center justify-between border-b border-grey-lighter">
                    <div class="">
                        <div class="justify-start" style="font-size: 0;">
                            <div class="inline-block align-middle">
                                <span @click="refreshCurrent" class="text-lg text-grey mr-4" :class="{'rotate': loadingfiles}">
                                    <app-icon icon="sync" />
                                </span>
                            </div>

                            <div class="inline-block align-middle mr-4">
                                <label class="manual_upload cursor-pointer">
                                    <app-button element="div" @click="showUpload = !showUpload" class="btn btn--primary btn--primary--sml">
                                        Upload
                                    </app-button>
                                    <input type="file" multiple="true" @change="uploadFilesByButton"/>
                                </label>
                            </div>

                            <div class="inline-block align-middle mr-4">
                                <app-button element="button" @click="showModalCreateFolder" class="btn btn--secondary btn--secondary--sml">
                                    Create folder
                                </app-button>
                            </div>
                        </div>
                        <!-- <div class="w-1/3 flex flex-wrap justify-end">
                            <div class="relative z-50 w-full max-w-xs">
                                <div class="relative">
                                    <div class="relative">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" aria-labelledby="search" role="presentation" class="fill-current absolute search-icon-center ml-3 text-70"><path fill-rule="nonzero" d="M14.32 12.906l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387a8 8 0 1 1 1.414-1.414zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"></path></svg>
                                        <input @input="searchItems" v-model="search" type="search" placeholder="Search" class="pl-search form-control form-input form-input-bordered w-full">
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>

                    <div class="flex-grow text-right">
                        <div>
                            <app-button element="button" @click="changeToList" class="btn btn--tertiary btn--tertiary--sml" v-bind:class="{'active': view == 'list'}">
                                <app-icon icon="list" />
                            </app-button>
                            <app-button element="button" @click="changeToGrid" class="btn btn--tertiary btn--tertiary--sml" v-bind:class="{'active': view == 'grid'}">
                                <app-icon icon="th-large" />
                            </app-button>
                        </div>
                    </div>
                </div>

                <app-manager
                    ref="manager"
                    :files="files"
                    :path="path"
                    :current="currentPath"
                    :noFiles="noFiles"
                    :view="view"
                    :loading="loadingfiles"
                    @goToFolderManager="goToFolder"
                    @goToFolderManagerNav="goToFolderNav"
                    @refresh="refreshCurrent"
                    @uploadFiles="uploadFiles"
                    @showInfoItem="showInfoItem"
                />

                <app-detail-popup
                    ref="detailPopup"
                    :info="info"
                    :active="activeInfo"
                    @closePreview="closePreview"
                    @refresh="refreshCurrent"
                    @info-close="closePreview"
                />

                <app-upload-progress 
                    ref="uploader" 
                    :current="currentPath" 
                    @removeFile="removeFileFromUpload" 
                />
            </div>

        </div>
    </div>
</template>

<script>
    import URI from 'urijs';
    import _ from 'lodash';
    import api from './api';

    import Heading from '@/components/Heading';
    import Button from '@/components/Button';
    import Manager from '@/components/filemanager/Manager';
    import CreateFolderModal from '@/components/filemanager/CreateFolderModal';
    import DetailPopup from '@/components/filemanager/DetailPopup';
    import UploadProgress from '@/components/filemanager/UploadProgress';

export default {
    components: {
        'app-manager': Manager,
        'app-heading': Heading,
        'app-button': Button,
        'app-create-folder': CreateFolderModal,
        'app-detail-popup': DetailPopup,
        'app-upload-progress': UploadProgress,
    },

    props: {
        presetPath: {
            type: String,
            required: false
        },
    },

    data: () => ({
        loaded: false,
        loadingfiles: false,
        activeDisk: null,
        activeDiskBackups: [],
        backupStatusses: [],
        showUpload: false,
        showCreateFolder: false,
        currentPath: '/',
        files: [],
        path: [],
        noFiles: false,
        view: 'grid',
        info: {},
        filesToUpload: [],
        activeInfo: false,
        search: '',
    }),

    async created() {
        let currentUrl = new URI();

        if (currentUrl.hasQuery('path')) {
            let params = currentUrl.query(true);
            this.currentPath = params.path;
        } else if (this.presetPath) {
            let path = this.presetPath.replace(/^\/|\/$/g, '');
            this.$router.push({ query: { path: path } })
            this.currentPath = path;
        }

        await this.getData(this.currentPath);

        this.loaded = true;
    },

    methods: {
        getData(pathToList) {
            this.files = [];
            this.path = [];
            this.noFiles = false;
            this.loadingfiles = true;
            return api.getData(pathToList).then(result => {
                if (_.size(result.files) == 0) {
                    this.noFiles = true;
                }
                this.files = result.files;
                this.path = result.path;
                this.loadingfiles = false;
            });
        },

        showModalCreateFolder() {
            this.showCreateFolder = true;
        },
        closeModalCreateFolder() {
            this.showCreateFolder = false;
        },

        refreshCurrent() {
            this.getData(this.currentPath);
        },

        refreshCurrentAfterUpload() {
            this.getData(this.currentPath);
            this.filesToUpload = [];
        },

        goToFolder(path) {
            this.getData(path);
            this.currentPath = path;
            history.pushState(null, null, '?path=' + path);
        },

        goToFolderNav(path) {
            this.getData(path);
            this.currentPath = path;
            if (this.currentPath == '/') {
                history.pushState(null, null, '?path=' + path);
            } else {
                history.pushState(null, null, '?path=' + path);
            }
        },

        changeToList() {
            this.view = 'list';
            localStorage.setItem('view', 'list');
        },

        changeToGrid() {
            this.view = 'grid';
            localStorage.setItem('view', 'grid');
        },

        showInfoItem(item) {
            this.activeInfo = true;
            this.info = item;
        },

        closePreview() {
            this.info = {};
            this.activeInfo = false;
            this.popupDetailsLoaded = false;
        },

        uploadFiles(files) {
            this.filesToUpload = files;
            this.$refs.uploader.startUploadingFiles(files);
        },

        removeFileFromUpload(uploadedFileId) {
            let index = this.filesToUpload.map(item => item.id).indexOf(uploadedFileId);

            this.$delete(this.filesToUpload, index);
            if (this.filesToUpload.length === 0) {
                this.refreshCurrent();
            }
        },

        uploadFilesByButton(e) {
            this.$refs.manager.uploadFiles(e.target.files);
        },

        searchItems: _.debounce(function(e) {
            this.search = e.target.value;

            // Do search
            // this.$refs.manage.search(this.search)
        }, 300),
    },

    computed: {
        cssFilemenagerContainer() {
            if (this.cssDragAndDrop == 'inside') {
                return 'bg-20';
            }

            if (this.cssDragAndDrop == 'outside') {
                return '';
            }
            return '';
        },
    },
};
</script>

<style scoped lang="scss">
.manual_upload > input[type='file'] {
    display: none;
}

.btn-small {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.3rem;
    fill: #fff;
}

.rotate {
    svg {
        animation: fa-spin 2s infinite linear;
    }
}

@keyframes fa-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/filemanager/Filemanager.vue